import { inject, Injectable } from '@angular/core';
import { RequestBuilder } from '@hereisyourgitanton/crm-api2';
import { HttpClient } from '@angular/common/http';
import { TRADGINE_DATA_API_BASE_URL } from '../api-base-url.token';
import { OrganizationResponseDto } from '../schemas/organization-response.dto';

@Injectable({ providedIn: 'root' })
export class OrganizationApi {
    private readonly builder: RequestBuilder = new RequestBuilder(inject(HttpClient));
    private readonly controllerUrl = `${inject(TRADGINE_DATA_API_BASE_URL)}/Organization`;

    getCurrentOrganization() {
        return this.builder
            .url(`${this.controllerUrl}/GetCurrentOrganization`)
            .get()
            .json<OrganizationResponseDto>()
            .build()
            .send();
    }
}
